module.exports = __webpack_public_path__ + "static/media/rice.6ce8e474.svg";